import mainStyle from '../org-management.module.scss';

// Components
import MessageBoxGroup from 'components/MessageBoxGroup';
import Breadcrumbs from 'components/Breadcrumb';

// Sub compoent
import OrgTreeToolbarBox from './OrgTreeToolbarBox';
import OrgTreeTreeView from './OrgTreeTreeView';
import OrgTreeTableView from './OrgTreeTableView';

import ModalComponents from '../ModalComponents';
import ResultModalContainer from 'components/ResultModalContainer';

import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from 'react';
import { useParams } from "react-router-dom"; // get value from router loader.
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';


import { loadGuiBootstarp, loadOrgBootstarp } from "stores/slice/fetchStatus";
import { PATH } from "router/config/const";
import { cloneDeep, isNil, size } from 'lodash';
import dayjs from "dayjs";
import { jsonToCsv } from "utils/downloadFile.util";

import { defaultMessages, getDefaultModalStatus } from "../const";

import controller, { defaultTreePathList } from './controller';

import { messageKeyPrefix } from "utils/message.util";
import Nuclias from "const/nuclias";
const { organizationType, timeFormat, userType } = Nuclias;

const deviceResultTitle = ['ec53a8c4f0', '92394ac496', '3ec365dd53']

const OrganizationTree = () => {
  const { id } = useParams(); // orgId
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const defaultModalStatus = getDefaultModalStatus();
  const { pageContext, user: { user } } = useSelector((store) => store);
  const [breadcrumbs, setBreadcrumbs] = useState(cloneDeep(defaultTreePathList));
  const [multiMessages, setMultiMessages] = useState(cloneDeep(defaultMessages));
  const [modalStatus, setModalStatus] = useState(cloneDeep(defaultModalStatus));
  const [viewStatus, setViewStatus] = useState({ treeView: true, collapse: false });
  const [info, setInfo] = useState({});
  const [treeData, setTreeData] = useState({});
  const [seachValue, setSearchValue] = useState(null);

  const [deviceResult, setDeviceResult] = useState([]);

  const init = async () => {
    const resInfo = controller.getInfo()
    setInfo(resInfo)
    getBreadcrumbs(resInfo.orgDs)
    setTreeData(await controller.getOrgTree())
  }

  const getBreadcrumbs = (orgDs) => {
    const treePath = cloneDeep(defaultTreePathList)
    treePath[2].label = orgDs.name
    setBreadcrumbs(treePath)
  }

  const checkOrg = async () => {
    if (!pageContext.selectedOrg || pageContext.selectedOrg.id !== parseInt(id))
      dispatch(loadOrgBootstarp(parseInt(id)));
  }

  const handleModals = useCallback((params) => {
    const tmpModalStatus = { ...modalStatus };
    tmpModalStatus[params.modal].status = params.status;
    tmpModalStatus[params.modal].type = params.type;
    if (params.editObj)
      tmpModalStatus[params.modal].editObj = params.editObj;
    else
      delete tmpModalStatus[params.modal].editObj

    setModalStatus(tmpModalStatus);
  }, []);

  const submitModal = (result) => {
    // console.log('submitModal', result)
    const copy = cloneDeep(defaultMessages)
    if (!isNil(result?.error)) {
      copy.error = t(`${messageKeyPrefix.e.s}${result.error.code}`)
    } else {
      copy.success = t(`${messageKeyPrefix.s.c}1001`)
      submitSuccess(result)
      window.scrollTo(0, 0)
    }
    setMultiMessages(copy)
  }

  const submitSuccess = (result) => {
    if (result?.exitPage) {
      setTimeout(function () {
        dispatch(loadOrgBootstarp())
        navigate(PATH.settings.organization);
      }, 2000)
    } else if (info.userType === userType.si)
      dispatch(loadOrgBootstarp(parseInt(id)))
    else {
      dispatch(loadGuiBootstarp())
    }

    if (result?.pushResult) {
      const res = controller.genPushDeviceResult(result?.pushResult)
      setDeviceResult(res)
      handleModals({ modal: 'result', status: true })
    }
  }

  const downloadResult = useCallback(() => {
    let fields = ['status', 'target', 'details'];
    let headers = deviceResultTitle;
    const fileName = `${'ORG_Site Push'}_${dayjs().format(timeFormat.csvDownloadFormat)}.csv`;
    jsonToCsv(fileName, headers, fields, deviceResult);
  }, [deviceResult]);

  useEffect(() => {
    if (pageContext.selectedOrg && pageContext.selectedOrg.id === parseInt(id)) init()
  }, [pageContext]);

  useEffect(() => {
    if (isNil(id)) {
      // navigate(PATH.settings.organization);
      return
    }
    checkOrg()
  }, [id]);

  return (
    <>
      <Breadcrumbs pathList={breadcrumbs} />
      <div className={`layout-container layout-container--column layout-container--fluid ${mainStyle['org-tree-msp']}`}>

        <MessageBoxGroup
          messages={multiMessages}
          onClose={type => setMultiMessages({ ...multiMessages, [type]: null })}
        />
        <OrgTreeToolbarBox {...{
          info, handleModals, viewStatus, setViewStatus, seachValue, setSearchValue
        }} />
        {
          viewStatus?.treeView &&
          <OrgTreeTreeView {...{ info, treeData, viewStatus, modalStatus, handleModals }} />
        }
        {
          !viewStatus?.treeView &&
          <OrgTreeTableView {...{ treeData, handleModals, seachValue }} />
        }
        <ModalComponents {...{ info, modalStatus, handleModals, submitModal }} />

        {
          modalStatus?.result?.status &&
          <ResultModalContainer
            thList={deviceResultTitle}
            results={deviceResult}
            onDownload={() => downloadResult()}
            openModal={modalStatus?.result?.status}
            closeModal={() => handleModals({ modal: 'result', status: false })}
          />
        }
      </div>
    </>
  );
};

export default OrganizationTree;
